<template>
  <div class="ibox" v-if="can_show_component">
    <div   class="ibox-content border-radius-12">
      <p class="font-size-18 bold">
        <span class="select-services-dropdown-title">Upcoming appointments</span>
      </p>
      <div v-for="(visit,index) of all_visits"  class="row upcoming-content m-0 custom_data_style">
          <div class="col-lg-12 col-md-12 col-xs-12 p-left-0 p-right-0">
            <div class="col-md-9 col-xs-9 p-left-0 top-7">
              <div class="col-md-3 col-xs-3">
                <div class="date-box">
                     {{ DateFormatted(visit.startDate) }}
                </div>
              </div>
              <div class="col-md-9 col-xs-9">
                <div class="col-md-12">  {{ visit.startTime }}   -    {{ visit.endTime }}   <span v-if="customer && customer.timezone">  {{ getTimezoneIdentifier(customer.timezone) }}</span></div>
                <div class="col-md-12">
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.18 4.81219C10.3025 3.93469 9.155 3.49219 8 3.49219V7.99219L4.82 11.1722C6.575 12.9272 9.425 12.9272 11.1875 11.1722C12.9425 9.41719 12.9425 6.56719 11.18 4.81219ZM8 0.492188C3.86 0.492188 0.5 3.85219 0.5 7.99219C0.5 12.1322 3.86 15.4922 8 15.4922C12.14 15.4922 15.5 12.1322 15.5 7.99219C15.5 3.85219 12.14 0.492188 8 0.492188ZM8 13.9922C4.685 13.9922 2 11.3072 2 7.99219C2 4.67719 4.685 1.99219 8 1.99219C11.315 1.99219 14 4.67719 14 7.99219C14 11.3072 11.315 13.9922 8 13.9922Z" fill="#2E4051"/>
                  </svg>
                    {{ calculate_booking_duration_by_start_and_end_for_admin_vue_js(visit.startDate,visit.startTime,visit.endDate,visit.endTime) }}
                </div>
              </div>
            </div>
            <div class="col-md-3 col-xs-3 custom-jusstify-end">

<!--                     <span v-if="visit.tracking_details && visit.tracking_details[0].timestamps" class="float-right day-box">

                                  <span v-if="visit.tracking_details[0].timestamps.checkout"  >
                                        {{ DateFormatted_the_day( visit.tracking_details[0].timestamps.checkout ) }}
                                  </span>

                                  <span v-else-if="visit.tracking_details[0].timestamps.checkin"  >
                                        {{ DateFormatted_the_day( visit.tracking_details[0].timestamps.checkin ) }}
                                  </span>

                                  <span v-else-if="visit.tracking_details[0].timestamps.arrived"  >
                                        {{ DateFormatted_the_day( visit.tracking_details[0].timestamps.arrived ) }}
                                  </span>

                                  <span v-else-if="visit.tracking_details[0].timestamps.on_the_way"  >
                                        {{ DateFormatted_the_day( visit.tracking_details[0].timestamps.on_the_way ) }}
                                  </span>
                     </span>-->


                    <span v-if="visit.startDate " class="float-right day-box">
                                 {{ DateFormatted_the_day( visit.startDate ) }}
                    </span>


            </div>
          </div>
          <div class=" f col-md-12 col-xs-12 p-left-0 p-right-0 p-top-10 p-bottom-10 border-style ">
              <div class="col-md-8 col-xs-8 p-left-0  p-top-5">
                  <div class="col-md-3 col-xs-3">
                      <div class="p-left-12"><div v-html="visit.contractor_img"></div></div>
                  </div>
                  <div class="col-md-9 col-xs-9">
                      <div class="position-relative top-5">
                          <span>{{ visit.contractorInfo.username }}</span>
                      </div>
                  </div>
              </div>
              <div class="col-md-4 col-xs-4">
                  <div  v-if="visit.visit_status != 'accepted'" class="col-md-2 col-xs-2 custom-pl-2 custom-mb-0 top-8 popover-container">
<!--                  <div v-if="visit.visit_status != 'accepted'" class="col-md-2 custom-pl-2 custom-mb-0 top-8">-->
                    <a :data-content="popover_custom_data('Pending acceptance')" data-html="true"
                          data-placement="bottom" data-toggle="popover" style="cursor: pointer">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#FF932F"/>
                      </svg>
                    </a>

                  </div>

                  <confirm-attendance-button
                      v-if=" viewPage &&  fieldworkerVisitStatus(visit.visit_status,visit.visit_confirmed).visit_confirmed =='Confirmed'"
                      :title="fieldworkerVisitStatus(visit.visit_status,visit.visit_confirmed).visit_confirmed"
                      :class-div=" visit.visit_status == 'accepted' ? `confirm-btn float-right indicator_to_accept_or_not_${visit.id}_${visit.booking_id}` : `confirm-btn float-right disabled_confirm_attendance_button indicator_to_accept_or_not_${visit.id}_${visit.booking_id}`"
                      :element-id="`custom_object_${visit.booking_id}`"
                      :booking-id='`${visit.booking_id}`'
                      :optional-visit-id='`${visit.multiple_day_id}`'
                      :info-for-confirmation="getInfoForConfirmation( 'Technician',`${visit.contractor_id}` ,`${visit.contractorInfo.username}`,`${visit.booking_id}`)"
                  >
                  </confirm-attendance-button>
                  <confirm-attendance-button
                      v-if="  viewPage &&  fieldworkerVisitStatus(visit.visit_status,visit.visit_confirmed).visit_confirmed  !='Confirmed'"
                      :title="fieldworkerVisitStatus(visit.visit_status,visit.visit_confirmed).visit_confirmed"
                      :class-div=" visit.visit_status == 'accepted' ? `confirm-btn float-right indicator_to_accept_or_not_${visit.id}_${visit.booking_id}` : `confirm-btn float-right disabled_confirm_attendance_button indicator_to_accept_or_not_${visit.id}_${visit.booking_id}`"
                      :element-id="`custom_object_${visit.booking_id}`"
                      :booking-id='`${visit.booking_id}`'
                      :optional-visit-id='`${visit.multiple_day_id}`'
                      :info-for-confirmation="getInfoForConfirmation( 'Technician',`${visit.contractor_id}` ,`${visit.contractorInfo.username}`,`${visit.booking_id}`)"
                  >
                  </confirm-attendance-button>
              </div>
          </div>
          <div class=" c col-md-12 col-xs-12 p-left-0 p-right-0 p-top-10 p-bottom-10" v-if="canSeeCustomer || loggedUserRole  != 'contractor'" >
            <div class="col-md-8 col-xs-8 p-left-0 p-top-5">
              <div class="col-md-3 col-xs-3">
                <div class="p-left-12" v-if="customer.avatar_html">
              <div v-html="customer.avatar_html"></div>

                </div>

               </div>
              <div class="col-md-9 col-xs-9">
                <span class="position-relative top-5">
                  {{ customer.first_name}} {{ customer.last_name}}
                </span>
               </div>
            </div>
            <div class="col-md-4 col-xs-4">


                    <confirm-attendance-button
                        v-if=" viewPage &&    !visit.Customer_visit_confirmed  "
                        :button-confirm-status="0"
                        title ="Confirm"
                        class-div=" confirm-btn float-right "
                        :element-id="`custom_object_${visit.booking_id}`"
                        :booking-id="visit.booking_id"
                        :info-for-confirmation="getInfoForConfirmation( 'customer',`${customer.customer_id}` ,`${customer.first_name}`,`${visit.booking_id}`)"

                    >

                    </confirm-attendance-button>

                    <confirm-attendance-button
                        v-if=" viewPage &&    visit.Customer_visit_confirmed  "

                        :button-confirm-status="1"
                        title ="Confirmed"
                        class-div=" confirm-btn float-right"
                        :element-id="`custom_object_${visit.booking_id}`"
                        :booking-id="visit.booking_id"
                        :info-for-confirmation="getInfoForConfirmation( 'customer',`${customer.customer_id}` ,`${customer.first_name}`,`${visit.booking_id}`)"
                        date-confirm=''
                    >
                    </confirm-attendance-button>



             </div>
          </div>
        <div v-else class="col-md-8 col-xs-8 p-left-20 p-top-20 p-bottom-15">
          <span class="select-services-dropdown-title" style="font-size: 18px;">Customer details hidden</span>
        </div>
       </div>
    </div>
  </div>

</template>

<script>


import _ from "lodash";
import moment from "moment-timezone";
import {EventBus} from "@/events/event-bus";

import Vue from "vue";

export default {
    name: "upcomingAppointments",
    props:{
       booking:null,
       customer:null,
       viewPage:null,
       canSeeCustomer: null,
       loggedUserRole: null,
    },

    data(){
      return {

      upcomingAppointmentsVisits:null,
          estimateStatus:null,
          customer_data_val:null,
          can_show_component:true,
          all_visits:[],
      }
    },
    computed:{
        isMobile() {
            return this.getWidth() <= 768;
        },

        itemType() {
            if (this.allObject.toEstimate){
                return 'estimate'
            }
            else if (this.allObject.toInvoice){
                return 'invoice'
            }
            else if (this.allObject.gift_card){
                return 'gift_card'
            }
            else if ((this.allObject.event || {}).booking_id){
                return 'booking'
            }
            else if ( ( (this.allObject.event || {}).inquiry_id ) || this.isInquiry){
                return 'inquiry'
            }
            else {
                return 'booking'
            }
        },
          },
    methods:{

         getTimezoneIdentifier(timezone) {
                if (timezone) {
                    // The options object for formatting the date-time with the timezone and offset
                    const options = {
                        timeZone: timezone,
                        timeZoneName: 'short'
                    };

                    // Create a new Date object for the current time
                    const now = new Date();

                    // Intl.DateTimeFormat object to format the date according to the given options
                    const formatter = new Intl.DateTimeFormat('en-US', options);

                    // Get the formatted date-time string, which includes the short timezone name and offset
                    const formattedDateTime = formatter.format(now);

                    // Extract the GMT offset and the timezone abbreviation from the formatted string
                    // The format is dependent on the implementation and might need adjustment
                    const match = formattedDateTime.match(/GMT([\+\-]\d+)(\s\w+)?/);
                    if (match) {
                        const offset = match[1]; // The GMT offset part, e.g., +0200
                        const timezoneAbbr = match[2] ? match[2].trim() : ''; // The timezone abbreviation, if available
                        const timezoneIdentifier = `(GMT${offset}) ${timezone} ${timezoneAbbr}`;
                        return timezoneIdentifier;
                    }

                    // If the regex match fails, fallback to just the timezone
                    return timezone;
                }

                return "No Timezone Provided";
            },
        getInfoForConfirmation(item_type='Technician' ,id, name, item_id_data) {
            if(item_type =='Technician'){
                return {
                    item_type: item_type,
                    id: parseInt(id),  // Assuming `visit` is part of your data
                    name: name,
                    item_id: item_id_data
                };
            }else {
                return {
                    item_type: item_type,
                    id: parseInt(id),  // Assuming `visit` is part of your data
                    name: name,
                    item_id: item_id_data
                };
            }

      },
      fieldworkerVisitStatus(visit_status=null,visit_confirmed_status=null) {


        let title_confirmation ;
        let visit_confirmed;
        let routeName
        let title
        let img
        let divClass
        let visit_confirmed_divClass
        let style;
        if (visit_status ==="accepted")  {
          divClass = 'confirm-color';
          title_confirmation= 'Accepted';
          routeName = 'rejectServices';
          title = 'Decline Appointment';
          img = '/pic/white_accepted.png';
          style = '';
        }
        else if ( visit_status === 'declined') {
          divClass = 'unconfirm-color';
          title_confirmation = 'Declined';
          routeName = 'acceptServices';
          title = 'Accept Appointment';
          img = '/pic/white_rejected.png';
          style = '';

        } else {

          divClass = 'unconfirm-color';
          title_confirmation = 'Pending';
          routeName = 'acceptServices';
          title = 'Accept Appointment';
          img = '/pic/white_unknown.png';
          style = '';
        }

        if (visit_confirmed_status){
            visit_confirmed= 'Confirmed';
            visit_confirmed_divClass= 'unconfirm-color';
        }else {
            visit_confirmed= 'Confirm';
            visit_confirmed_divClass= 'confirm-color';
        }
        return {
          title_confirmation,
          visit_confirmed,
          visit_confirmed_divClass,
          divClass,
          routeName,
          img,
          title,
          style
        }
      },
      getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
         getAppointments() {
            var vm =this;
         var array_push_data=[];
      this.booking.services_details.forEach((bookingServices_val)=>{
        if( bookingServices_val.service_id != 0 ){


                 if(bookingServices_val.visits.length){
                     bookingServices_val.visits.forEach(item => {
                         let timeInTimeZone = moment.tz(item.startDateTime, item.timezone);
                         let offset = timeInTimeZone.utcOffset()/60;
                         if (offset > 0) {
                             // Return the number as a string with a leading '+'
                             offset =  `+${offset}`;
                         }
// Create a date object for Sydney timezone (UTC+10:00)
                         let browserStartTime = new Date(item.startDateTime +' GMT'+offset);
                         if (browserStartTime > new Date()) {
                             //getDate()
                             vm.can_show_component=true
                            array_push_data.push(item);
                         }else {
                             vm.can_show_component=null
                         }

                    })
                }

        }

            })

            this.all_visits=array_push_data;


        },
      DateFormatted(startDate) {
         return moment(startDate).format("DD MMM")
         },

        DateFormatted_the_day(Date_opj) {
            // Assuming Date_opj is a Date object. If it's a string, you must first parse it: var Date_opj = new Date('Your date string here');
            var Date_opj = new Date(Date_opj); // Replace this with your actual Date_opj initialization

            // Create a new date object for the current date
            var currentDate = new Date();

            // Set the time of currentDate to 00:00:00 for accurate comparison
            currentDate.setHours(0, 0, 0, 0);

            // Create a new date object for tomorrow based on the current date
            var tomorrow = new Date(currentDate);
            tomorrow.setDate(tomorrow.getDate() + 1);

            // Compare Date_opj to tomorrow (ignoring time part)
            if (Date_opj.getFullYear() === tomorrow.getFullYear() &&
                Date_opj.getMonth() === tomorrow.getMonth() &&
                Date_opj.getDate() === tomorrow.getDate()) {
               return 'Tomorrow';
            } else if (Date_opj.getFullYear() === currentDate.getFullYear() &&
                Date_opj.getMonth() === currentDate.getMonth() &&
                Date_opj.getDate() === currentDate.getDate()) {
                return 'Today';
            } else {
                return moment(Date_opj).format("dddd")
            }


        },
      calculate_booking_duration_by_start_and_end_for_admin_vue_js(startDate,startTime,endDate,endTime) {

            let  startMoment = moment(startDate + " " + startTime);
            let  endMoment = moment(endDate + " " +endTime);
            let duration = moment.duration(endMoment.diff(startMoment));
            let  all_duration="";
            if (duration._data.days && duration._data.days != "undefined " && duration._data.days !=0 ){
                all_duration = duration._data.days+"day";
            }
            if (duration._data.hours    && duration._data.hours != "undefined " && duration._data.hours !=0 ){
                all_duration = all_duration+" "+duration._data.hours+"hr";
            }
            if (duration._data.minutes && duration._data.minutes != "undefined "  && duration._data.minutes !=0 ){
                all_duration = all_duration+" "+duration._data.minutes+"min";
            }

            return all_duration ;
        },
      popover_custom_data(value) {
        return `<div class="font-size-13 font-weight-100 popover_custom_data ">${value}</div>`;
      },
    },
    mounted() {
             this.getAppointments();

      EventBus.$on('visitStatusChanged',(visit)=>{

        if (visit){

           let find_visit = this.all_visits.find(visit_opj => visit_opj.id === visit.id);
            find_visit.visit_status = visit.type;
          var element = document.getElementsByClassName(`indicator_to_accept_or_not_${find_visit.id}_${find_visit.booking_id}`);
            if( visit.type =='accepted' && element){
               element[0].classList.remove('disabled_confirm_attendance_button');
            }else{
            element[0].classList.add('disabled_confirm_attendance_button');
            }








          //
          // this.visit.visit_status = visit.type;
          // let divClass;
          // let title_confirmation;
          // if (visit.type ==="accepted")  {
          //   divClass = 'confirm-color';
          //   title_confirmation= 'Accepted';
          //   this.visit.accepted_at = visit.accepted_at
          // }
          // else if ( visit.type === 'declined') {
          //   divClass = 'unconfirm-color';
          //   title_confirmation = 'Declined';
          // } else {
          //   divClass = 'unconfirm-color';
          //   title_confirmation = 'Pending';
          // }
          // this.visit.fieldworkerVisitStatus.title_confirmation = title_confirmation;
          // this.visit.fieldworkerVisitStatus.divClass =  divClass;
        }
      })


    },

}
</script>

<style scoped>
.custom-pl-2{
    padding-left:4px ;
}
.custom-jusstify-end
{
    display: flex;
    justify-content: flex-end;
}
.custom-mb-0{
    margin-bottom: 0px;
}
.custom_data_style{
    margin-bottom: 12px!important;
}
.border-radius-12{
  border-radius: 12px;
}
.upcoming-content {
  border: 1px solid #E0E2E5;
  border-radius: 12px;
  Padding: 16px 0px 8px 0px;
  background-color: #FFFFFF;
}
.m-0 {
  margin: 0px;
}
.date-box{
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  padding: 2px 16px;
  background-color: #008CFA26;
  font-size: 17px;
  display: inline-block;
  text-align: center;
  color: #2E4051;
  font-weight: 400;
}
.day-box{
  background-color: rgba(0, 140, 250, 0.15) !important;
  color: #2E4051 !important;
  border-radius: 100px !important;
  padding: 3px 10px 6px 10px !important;
  width: auto !important;
  top: 10px;
  position: absolute;
}
.confirm-btn{
  border-radius: 8px !important;
  padding: 10px 10px !important;
  font-family: 'Roboto', serif !important;
  font-style: normal !important;
  font-weight: 500 !important;
  text-align: center !important;
  background-color: #008CFA !important;
  color: #FFFFFF !important;
  text-decoration: none !important;
}
.border-style {
  border-bottom: 1px solid;
  border-color: #EAECEE;
}
.disabled_confirm_attendance_button {
    background-color: #8ebcff!important;
    pointer-events: none; /* Prevents clicking */
    color: grey; /* Makes the link color grey to appear disabled */
    text-decoration: none; /* Removes underline from link */
    cursor: not-allowed; /* Changes cursor to not-allowed symbol */
}
@media (max-width: 991px) {
  .custom-pl-2 {
    padding-left: 0px;
  }
}
</style>